import { render, staticRenderFns } from "./RsaPrescrizioniCambioStatoModalComponent.vue?vue&type=template&id=301b992e"
import script from "./RsaPrescrizioniCambioStatoModalComponent.vue?vue&type=script&lang=js"
export * from "./RsaPrescrizioniCambioStatoModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports